import React from 'react'
import { useLocalization } from '@/hooks/localization'

function BoolRenderer ({ value }) {
  const { localize } = useLocalization()
  if (value === null || value === undefined || value === '') return <span />
  const text = value === true || value === 'True'
    ? 'Common.Yes'
    : 'Common.No'
  return (
    <span>
      {localize(text)}
    </span>
  )
}

export { BoolRenderer }



// WEBPACK FOOTER //
// ./src/components/report-tables/renderers/boolRenderer.js